module.exports = __webpack_public_path__ + "img/Group_39936@2x.aec2acb5.png";